// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig : {
    apiKey: "AIzaSyDP4o5--QLMi3avz-O6MBlpI_taReTfZA8",
    authDomain: "my-orders-app.firebaseapp.com",
    databaseURL: "https://my-orders-app.firebaseio.com",
    projectId: "my-orders-app",
    storageBucket: "my-orders-app.appspot.com",
    messagingSenderId: "283118312427"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
